import React from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { Info } from 'lucide-react';

interface DetailTooltipProps {
  title: string;
  content: React.ReactNode;
  children: React.ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
}

export default function DetailTooltip({ title, content, children, side = "top", align = "center" }: DetailTooltipProps) {
  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex-1">{children}</div>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Info className="h-4 w-4 text-blue-400 cursor-pointer flex-shrink-0" />
          </TooltipTrigger>
          <TooltipContent side={side} align={align} className="max-w-sm">
            <div>
              <div className="font-medium mb-1">{title}</div>
              {content}
            </div>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
